import React from "react";
import { connect } from "react-redux";
import { Images } from "../";
import { Enums } from "../../helpers";
import { changeFeed } from "../../redux/actions/appActions";
import { Carousel, Layout } from "antd";
import { getBannerImages } from "../../redux/actions/generalActions";
import { Loading, Alert } from "../";
import { AppConfig } from "../../helpers";
import { useMediaQuery } from "react-responsive";
import {
  getFieldsUpdatedDetails,
  setTab,
  updateBetSlip,
} from "../../redux/actions/betSlipActions";

const imgStyle = {
  width: "100%",
  borderRadius: "5px",
  maxHeight: "320px",
};

const IsMobile = ({ children }) => {
  const IsMobile = useMediaQuery({ maxWidth: 500 });
  return IsMobile ? children : null;
};
const IsUpperScreen = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 500 });
  return isDesktop ? children : null;
};
class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.myCourasel = React.createRef();
  }
  componentDidMount() {
    this.props.getBannerImages();
  }
  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (prevProps.sportType !== this.props.sportType) {
      this.myCourasel.current.goTo(0, true);
    }
  }
  onBannerClick(item) {
    const {
      updateBetSlip,
      setTab,
      history,
      getFieldsUpdatedDetails,
    } = this.props;

    if (typeof item.promoId == typeof 1 && item.bannerType !== 4) {
      history.push(`/promos/${item.promoId}`);
    } else if (
      item.bannerType == 4 &&
      item.oddsBoostOfferDetails &&
      item.oddsBoostOfferDetails[0]
    ) {
      setTab("2");
      const request = item.oddsBoostOfferDetails.map((offer) => ({
        ...offer,
        betType: { betTypeId: offer.betTypeId },
        sport: { sportId: offer.sportId },
        feed: { feedId: offer.feedId },
        oddSpecialField: offer.oddSpecialField,
      }));
      getFieldsUpdatedDetails(request);
      history.push(
        `/sport/${item.oddsBoostOfferDetails[0].feedId}/${item.oddsBoostOfferDetails[0].sportId}/${item.oddsBoostOfferDetails[0].sportDisplayName}/event/${item.oddsBoostOfferDetails[0].categoryId}/${item.oddsBoostOfferDetails[0].tournamentId}/${item.oddsBoostOfferDetails[0].eventId}`
      );
    } else if (item.routeUrl) {
      history.push(`${item.routeUrl}`);
    }
  }

  render() {
    const {
      promotionalBannersError,
      promotionalBanners,
      loadingBanners,
    } = this.props;
    const mobileFilterCurrentBanner =
      promotionalBanners &&
      promotionalBanners.mobileBannerImages.filter(
        (item) => item.sportType == Number(this.props.match.params.sport)
      );

    const desktopFilterCurrentBanner =
      promotionalBanners &&
      promotionalBanners.websiteBannerImages.filter(
        (item) => item.sportType == Number(this.props.match.params.sport)
      );

    const mobileFilterPromotionalBanners =
      promotionalBanners &&
      promotionalBanners.mobileBannerImages.filter(
        (item) => item.bannerType == 1 || item.bannerType == 4
      );

    const desktopFilterPromotionalBanners =
      promotionalBanners &&
      promotionalBanners.websiteBannerImages.filter(
        (item) => item.bannerType == 1 || item.bannerType == 4
      );

    // key={this.props.sportType}
    return (
      <div className="main-image" style={{ margin: "0px  10px 0px 0px" }}>
        <IsUpperScreen>
          <Carousel
            effect="fade"
            ref={this.myCourasel}
            dots={true}
            dotPosition={"bottom"}
            infinite={true}
            autoplay
          >
            {desktopFilterCurrentBanner && desktopFilterCurrentBanner[0] && (
              <div key={desktopFilterCurrentBanner[0].bannerID}>
                <img
                  style={imgStyle}
                  src={
                    desktopFilterCurrentBanner
                      ? `${desktopFilterCurrentBanner[0].bannerPath}?id=${desktopFilterCurrentBanner[0].imageVersion}`
                      : ""
                  }
                  alt="banner"
                />
              </div>
            )}
            {loadingBanners ? (
              <Loading />
            ) : promotionalBannersError ? (
              <Alert type="error" message={promotionalBannersError} />
            ) : desktopFilterPromotionalBanners ? (
              desktopFilterPromotionalBanners.map((item) => {
                const isClickable =
                  item.routeUrl ||
                  (typeof item.promoId == typeof 1 && item.bannerType !== 4) ||
                  (item.bannerType == 4 &&
                    item.oddsBoostOfferDetails &&
                    item.oddsBoostOfferDetails[0]);

                return (
                  <div key={item.bannerID}>
                    <img
                      onClick={() => this.onBannerClick(item)}
                      // style={imgStyle}
                      style={{
                        ...imgStyle,
                        cursor: isClickable ? "pointer" : "default",
                      }}
                      src={`${item.bannerPath}?id=${item.imageVersion}`}
                      alt="banner"
                    />
                  </div>
                );
              })
            ) : (
              ""
            )}
          </Carousel>
        </IsUpperScreen>
        <IsMobile>
          <Carousel
            effect="fade"
            ref={this.myCourasel}
            dots={true}
            dotPosition={"bottom"}
            infinite={true}
            autoplay
          >
            {mobileFilterCurrentBanner && mobileFilterCurrentBanner[0] && (
              <div key={mobileFilterCurrentBanner[0].bannerID}>
                <img
                  style={imgStyle}
                  src={
                    mobileFilterCurrentBanner
                      ? `${mobileFilterCurrentBanner[0].bannerPath}?id=${mobileFilterCurrentBanner[0].imageVersion}`
                      : ""
                  }
                  alt="banner"
                />
              </div>
            )}
            {loadingBanners ? (
              <Loading />
            ) : promotionalBannersError ? (
              <Alert type="error" message={promotionalBannersError} />
            ) : mobileFilterPromotionalBanners ? (
              mobileFilterPromotionalBanners.map((item) => {
                return (
                  <div key={item.bannerID}>
                    <img
                      onClick={() => this.onBannerClick(item)}
                      style={imgStyle}
                      src={`${item.bannerPath}?id=${item.imageVersion}`}
                      alt="banner"
                    />
                  </div>
                );
              })
            ) : (
              ""
            )}
          </Carousel>
        </IsMobile>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    feedId: state.app.feedId,
    promotionalBannersError: state.general.promotionalBannersError,
    loadingBanners: state.general.loadingBanners,
    promotionalBanners: state.general.promotionalBanners,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFeed: (feedId) => {
      dispatch(changeFeed(feedId));
    },
    getBannerImages: () => {
      dispatch(getBannerImages());
    },
    updateBetSlip: (field) => {
      dispatch(updateBetSlip(field));
    },
    setTab: (tab) => {
      dispatch(setTab(tab));
    },
    getFieldsUpdatedDetails: (request) =>
      dispatch(getFieldsUpdatedDetails(request)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
